// extracted by mini-css-extract-plugin
export var burger = "lcNavbar-module--burger--f4bca";
export var container = "lcNavbar-module--container--2aa69";
export var header = "lcNavbar-module--header--d82b3";
export var lcLogoLink = "lcNavbar-module--lcLogoLink--02f6b";
export var logo = "lcNavbar-module--logo--cf03a";
export var noScroll = "lcNavbar-module--no-scroll--4ffb8";
export var productUpdatesPage = "lcNavbar-module--productUpdatesPage--42f02";
export var searchCtn = "lcNavbar-module--searchCtn--5a838";